export const site = {
    /**
    * Gets the programmatic name of the entire locale, with the language, 
    *   country and variant separated by underbars. The Language is always lower case, 
    *   and country is always upper case. If the language is missing, 
    *   the string will begin with an underscore character. 
    *   If both the language and country fields are missing, 
    *   this function will return the empty string, 
    *   even if the variant field is filled in (you cannot have a locale with just a variant-- 
    *   the variant must accompany a valid language or country code). Examples: "en"
    *
    */
    en: {
        site:'Site',
        create_site:'Create Site',
        site_management:'Site Management',
        add_site:'Add Site',
        edit_site:'Edit Site',
        cancel:'cancel',
        submit:'submit',
        site_information:'Site Information',
        site_name:'Site Name',
        city:'city',
        state:'state',
        country:'country',
        pincode:'pinCode',
        site_status:'Site Status',
        site_id:'Site ID',
        customer_id:'Customer ID',
    },

    ar: {
        site:'الموقع',
        create_site:'إنشاء موقع',
        site_management:'إدارة الموقع',
        add_site:'أضف الموقع',
        edit_site:'تحرير الموقع',
        cancel:'إلغاء',
        submit:'إرسال',
        site_information:'معلومات الموقع',
        site_name:'اسم الموقع',
        city:'المدينة',
        state:'الحالة',
        country:'البلد',
        pincode:'بينكود',
        site_status:'حالة الموقع',
        site_id:'معرف الموقع',
        customer_id:'هوية الزبون',
    }
}